'use strict';

/**
 * css-loader v7 emits named CSS module exports only. @tempus/t-shared still
 * default-imports Boron typography (`import typography from '...module.scss'`),
 * which TypeScript compiles to `__importDefault(require(...)).default.className`.
 *
 * Re-export named classes plus a real `default` so t-shared and therapies
 * (`import * as typography`) both work.
 *
 * Load the SCSS via a relative path so this file does not match the webpack
 * alias that points at this stub.
 */
const typography = require('../node_modules/@tcl-boron-styles/typography/dist/index.module.scss');

module.exports = {
  ...typography,
  __esModule: true,
  default: typography.default || typography,
};
